/**
 * Daten der Wochen- und Monatsplanung (F-16), live aus der Datenbank.
 */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import type { FocusGoal, FokusArt } from '@/domain/planning/focus';
import type { ID } from '@/domain/types';

/**
 * Fokusziele eines Zeitraums; `undefined`, solange geladen wird. Mit
 * Schluessel, damit beim Blaettern nie die Ziele des vorigen Zeitraums
 * unter dem neuen Titel stehen.
 */
export function useFokusZiele(art: FokusArt, key: string): FocusGoal[] | undefined {
  const r = useLiveQuery(async () => ({
    k: `${art}:${key}`,
    rows: (await db.focusGoals.where('[art+key]').equals([art, key]).toArray()).sort((a, b) => a.order - b.order),
  }), [art, key]);
  return r?.k === `${art}:${key}` ? r.rows : undefined;
}

/** Alle Wochen- und Monatsziele, die auf ein grosses Ziel einzahlen. */
export function useFokusFuerZiel(goalId: ID): FocusGoal[] {
  return useLiveQuery(
    async () => (await db.focusGoals.where('goalId').equals(goalId).toArray())
      .filter((f) => f.status === 'offen' || f.status === 'erledigt')
      .sort((a, b) => b.key.localeCompare(a.key) || a.order - b.order),
    [goalId],
    [] as FocusGoal[],
  );
}
